export default __webpack_public_path__ + "static/media/footer-icon-2.43f77d49.svg";